export default __webpack_public_path__ + "static/media/Liby-android.388af97e.png";